import {
  FormFieldProps,
  resolveValue,
  useFormFieldErrorMessage
} from '@oncolens/oncolens-ui/lib/libraries/FormStore';
import { get } from 'lodash';
import React from 'react';
import useRequestFormStore from '../../RequestFormStore';

const RequestFormField = ({
  name,
  validationOptions = {
    validate: true
  },
  children
}: FormFieldProps) => {
  const value = useRequestFormStore((state) => get(state, name));
  const isDirty = useRequestFormStore((state) => state.isDirty)(name);
  const formSchema = useRequestFormStore((state) => state.schema);
  const errorMessage = useFormFieldErrorMessage(
    name,
    value,
    formSchema,
    isDirty,
    validationOptions
  );
  const updateField = useRequestFormStore((state) => state.updateField);
  const onChange = (event: any) => updateField(name, resolveValue(event));

  return (
    <>
      {children({
        value,
        onChange,
        errorMessage
      })}
    </>
  );
};

export { RequestFormField as default };
